import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import Editor from './Editor';

const GET_FACILITY = gql`
  query GetFacility($id: ID!) {
    facility(id: $id) {
      id
      discountPlans {
        id
        ...PromotionBannerEditorDiscountPlans
      }
    }
  }

  ${Editor.fragments.discountPlans}
  `;

const propTypes = {
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

const defaultProps = {};

const EditorContainer = ({
  facilityId,
  onFinishEdit,
  ...rest
}) => {
  const { data, loading, error } = useQuery(GET_FACILITY, { variables: { id: facilityId } });

  if (loading || error) {
    return null;
  }

  const { facility } = data || {};

  return (
    <Editor
      {...rest}
      facilityId={facilityId}
      promos={facility.discountPlans}
      onFinishEdit={onFinishEdit}
    />
  );
};

EditorContainer.propTypes = propTypes;
EditorContainer.defaultProps = defaultProps;

export default EditorContainer;
